(function () {
  var KEY = 'collection-view';

  function isCollectionPath(pathname) {
    return /\/collections\//.test(pathname);
  }

  var params = new URLSearchParams(window.location.search);
  if (isCollectionPath(window.location.pathname)) {
    localStorage.setItem(KEY, params.get('view') === 'single' ? 'single' : 'grid');
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href]');
    if (!link) return;

    var url = new URL(link.href, window.location.origin);
    if (!isCollectionPath(url.pathname) || url.searchParams.has('view')) return;

    if (url.pathname === window.location.pathname) {
      localStorage.setItem(KEY, 'grid');
      return;
    }

    if (localStorage.getItem(KEY) === 'single') {
      url.searchParams.set('view', 'single');
      link.href = url.href;
    }
  });
})();
